import * as designatingOfficial from './designatingOfficial';
import * as primaryOfficialDetails from './primaryOfficialDetails';
import * as institutionDetails from './institutionDetails';
import * as institutionDetailsFacility from './institutionDetailsFacility';
import * as primaryOfficialTraining from './primaryOfficialTraining';
import * as primaryOfficialBenefitStatus from './primaryOfficialBenefitStatus';
import { institutionDetailsNoFacilityDescription } from './institutionDetailsNoFacilityDescription';
import * as institutionNameAndAddress from './institutionNameAndAddress';
import { additionalOfficialSummary } from './additionalOfficialSummary';
import * as additionalOfficialDetails from './additionalOfficialDetails';
import * as additionalOfficialTraining from './additionalOfficialTraining';
import * as additionalOfficialBenefitStatus from './additionalOfficialBenefitStatus';
import { additionalOfficialIntro } from './additionalOfficialIntro';
import { readOnlyCertifyingOfficialIntro } from './readOnlyCertifyingOfficialIntro';
import {
  readOnlyCertifyingOfficialSummaryPage,
  arrayBuilderOptions,
} from './readOnlyCertifyingOfficialSummaryPage';
import * as readOnlyCertifyingOfficial from './readOnlyCertifyingOfficial';
import * as remarksPage from './remarks';

export {
  designatingOfficial,
  primaryOfficialDetails,
  primaryOfficialTraining,
  institutionDetails,
  institutionDetailsFacility,
  primaryOfficialBenefitStatus,
  institutionDetailsNoFacilityDescription,
  institutionNameAndAddress,
  additionalOfficialSummary,
  additionalOfficialDetails,
  additionalOfficialTraining,
  additionalOfficialBenefitStatus,
  additionalOfficialIntro,
  readOnlyCertifyingOfficialIntro,
  readOnlyCertifyingOfficialSummaryPage,
  arrayBuilderOptions,
  readOnlyCertifyingOfficial,
  remarksPage,
};
